import { render, staticRenderFns } from "./TextOnlyIcon.vue?vue&type=template&id=39deaf86&scoped=true"
import script from "./TextOnlyIcon.vue?vue&type=script&lang=js"
export * from "./TextOnlyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39deaf86",
  null
  
)

export default component.exports